import FailIcon from "@mui/icons-material/Cancel";
import CompleteIcon from "@mui/icons-material/CheckCircleOutline";
import ScheduledIcon from "@mui/icons-material/InsertInvitationOutlined";
import ButtonWithIcon from "../TrueUI/Buttons/ButtonWithIcon";
import style from "./formBoxMain.module.css";

export default function FormBoxStatus() {
  return (
    <div className={style.formbox_status_container}>
      <ButtonWithIcon
        size="large"
        textButton="Scheduled"
        icon={<ScheduledIcon />}
        className={style.formbox_status_button}
        fullWidth={true}
      />
      <ButtonWithIcon
        size="large"
        textButton="Complete"
        icon={<CompleteIcon />}
        className={style.formbox_status_button}
        fullWidth={true}
      />
      <ButtonWithIcon
        size="large"
        textButton="Failed"
        icon={<FailIcon />}
        className={style.formbox_status_button}
        fullWidth={true}
      />
    </div>
  );
}
